import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const HealthCheckRedux = createActions(
  {
    postHealthCheckRequest: ['studentId', 'data', 'isTeacher', 'fromProfile'],
    postHealthCheckSuccess: ['data'],
    postHealthCheckFailure: ['errors'],
    postVirtualHealthCheckRequest: ['student', 'data'],
    postVirtualHealthCheckSuccess: ['data'],
    postVirtualHealthCheckFailure: ['errors'],
    resetError: [],
  },
  {
    prefix: 'HEALTH_CHECK_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = HealthCheckRedux
export const HealthCheckTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  sending: {
    fetching: false,
    error: null,
  },
}, {
  get: true,
})

/* ------------- Reducers ------------- */
const resetError = state => state.merge({ create: { fetching: false, error: null } }, d)

const postHealthCheckRequest = state => state.merge({
  sending: {
    fetching: true,
    error: null,
  },
  new_healthCheck: {
    error: '',
    success: false,
  },
}, d)

const postHealthCheckSuccess = (state, { data }) => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
  new_healthCheck: {
    error: '',
    success: true,
  },
  ...data,
}, d)

const postHealthCheckFailure = (state, { errors }) => state.merge({
  sending: {
    fetching: false,
    error: errors,
  },
  new_healthCheck: {
    success: false,
    error: errors[0],
  },
}, d)

const postVirtualHealthCheckRequest = state => state.merge({
  sending: {
    fetching: true,
    error: null,
  },
  new_virtualHealthCheck: {
    error: '',
    success: false,
  },
}, d)

const postVirtualHealthCheckSuccess = (state, { data }) => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
  new_virtualHealthCheck: {
    error: '',
    success: true,
  },
  ...data,
}, d)

const postVirtualHealthCheckFailure = (state, { errors }) => state.merge({
  sending: {
    fetching: false,
    error: errors,
  },
  new_virtualHealthCheck: {
    success: false,
    error: errors[0],
  },
}, d)


export const reducer = createReducer(
  INITIAL_STATE, {
    [Types.postHealthCheckRequest]: postHealthCheckRequest,
    [Types.postHealthCheckSuccess]: postHealthCheckSuccess,
    [Types.postHealthCheckFailure]: postHealthCheckFailure,
    [Types.postVirtualHealthCheckRequest]: postVirtualHealthCheckRequest,
    [Types.postVirtualHealthCheckSuccess]: postVirtualHealthCheckSuccess,
    [Types.postVirtualHealthCheckFailure]: postVirtualHealthCheckFailure,
    [Types.resetError]: resetError,
  },
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/HealthCheckRedux.js